module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="modal fade" id="aboutModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">\n  <div class="modal-dialog">\n    <div class="modal-content" id = "brandModal">\n      <div class="modal-header">\n          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button> &nbsp &nbsp\n          <div class="jumbotron">\n          <div class="lead">\n            <div id = "name">\n              Virtual Lab \n            </div>\n            <div id = "version">\n              ' +
((__t = (buildDate)) == null ? '' : __t) +
'\n            </div>\n          </div>\n          <img src="';
print(domain+'images/logo.gif');
__p += '" style="width:190px"> </img>\n                <div class="copyright"> \n                  © 2024 ChemCollective \n                </div>\n                <div class="permissions">\n                    ' +
((__t = (terms.permissions[language])) == null ? '' : __t) +
' <a href="http://chemcollective.org/">ChemCollective.org</a>\n                </div>\n                  <a class = "reportBug" href="http://chemcollective.org/"> \n                    ' +
((__t = (terms.reportBug[language])) == null ? '' : __t) +
'\n                  </a>\n                </h5> \n        </div>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
}